export { useSettingsIndexPageNavigator } from "#use-settings-index-page-navigator";
